import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faGripLines,
  faMagnifyingGlass,
} from "@fortawesome/free-solid-svg-icons";
import Logo from "../../components/Logo";
import { Button } from "react-bootstrap";
import { SearchShow } from "../../components/OffCanvas/SearchBox/SearchShow";

export const SubNavbar = ({
  categories,
  setSearchKeyword,
  handleSearch,
  search,
  searchKeyword,
  searchedItems,
  isGlobalSearchLoading,
  handelSearchedItemSelection,
}) => {
  const { isAuthenticated, user, logout } = useAuth();
  const [showSearch, setShowSearch] = useState(false);
  let navigate = useNavigate();

  //Function to show search sidebar
  const showSearchCanvas = () => {
    setShowSearch(true);
  };
  //Function to hide search sidebar
  const hideSearchCanvas = () => {
    setShowSearch(false);
  };
  return (
    <>
      <div className="header_btm">
        <nav className="navbar navbar-expand-lg border-bottom">
          <div className="container">
            <Link to="/" className="navbar-brand d-lg-none d-block">
              {/* <img src={logo} alt="logo" /> */}
              <img
                src={process.env.PUBLIC_URL + "/images/logo.png"}
                alt="User"
                width={180}
              />
            </Link>
            {/* <a className="navbar-brand d-lg-none d-block" href="index.html">
                <img src="img/logo.png" width="180" alt=""/>
            </a> */}
            <div className="d-flex align-items-center justify-content-center">
              <a
                href="#MobileSearchOffcanvas"
                onClick={showSearchCanvas}
                style={{
                  border: "1px solid grey",
                  borderRadius: "5px",
                  padding: "0.5rem",
                  width: "3rem",
                  backgroundColor: "white",
                }}
                data-bs-toggle="offcanvas"
                role="button"
                aria-controls="MobileSearchOffcanvas"
                className="search_product_mobile text-center d-lg-none d-block"
              >
                <FontAwesomeIcon icon={faMagnifyingGlass} size="sm" />
              </a>
              <button
                className="navbar-toggler ms-3 text-secondary"
                style={{
                  border: "1px solid grey",
                  borderRadius: "5px",
                  padding: "0.5rem",
                  width: "3rem",
                  backgroundColor: "white",
                }}
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#main_nav"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <FontAwesomeIcon icon={faGripLines} size="sm" />
              </button>
            </div>
            <div className="collapse navbar-collapse" id="main_nav">
              <ul className="navbar-nav">
              <li className="nav-item">
                </li>
                {categories && (
                  <li className="nav-item dropdown">
                    <a
                      className="nav-link  dropdown-toggle"
                      href="#"
                      data-bs-toggle="dropdown"
                    >
                      {" "}
                      Categories{" "}
                    </a>
                    <ul className="dropdown-menu fade-up">
                      {categories &&
                        categories.map((category, index) => {
                          return (
                            <li key={index}>
                              <Link
                                className="dropdown-item"
                                to={`/${category?.slug}`}
                              >
                                {category?.title}
                              </Link>
                              {/* <a className="dropdown-item" href="#">Smartphones</a> */}
                            </li>
                          );
                        })}
                      {/* <li><a className="dropdown-item" href="#">Smartphones</a></li>
                            <li><a className="dropdown-item" href="#">Laptops</a></li> */}
                    </ul>
                  </li>
                )}
                {/* <li className="nav-item dropdown">
                        <a className="nav-link  dropdown-toggle" href="#" data-bs-toggle="dropdown"> Variants </a>
                        <ul className="dropdown-menu fade-up">
                            <li><a className="dropdown-item" href="/mobiles?keyword=redmi">Redmi</a></li>
                            <li><a className="dropdown-item" href="/mobiles?keyword=oneplus">One Plus</a></li>
                            <li><a className="dropdown-item" href="/mobiles?keyword=samsung">Samsung</a></li>
                            <li><a className="dropdown-item" href="/mobiles?keyword=iphone">Apple</a></li>
                            <li><a className="dropdown-item" href="/mobiles?keyword=lenovo">Lenovo</a></li>
                            <li><a className="dropdown-item" href="/mobiles?keyword=nokia">Nokia</a></li>
                            <li><a className="dropdown-item" href="/mobiles?keyword=oppo">Oppo</a></li>
                            <li><a className="dropdown-item" href="/mobiles?keyword=asus">Asus</a></li>
                        </ul>
                    </li> */}
                <li className="nav-item">
                  <Link className="nav-link" to="/about-us">
                    About Us
                  </Link>
                </li>
                
                <li className="nav-item">
                  <Link className="nav-link" to="/contact-us">
                    Contact Us
                  </Link>
                </li>
              </ul>
              <ul className="navbar-nav ms-auto">
                {!isAuthenticated && (
                  <li className="nav-item dropdown">
                    <a
                      className="nav-link  dropdown-toggle"
                      href="#"
                      data-bs-toggle="dropdown"
                    >
                      {" "}
                      Supplier{" "}
                    </a>
                    <ul className="dropdown-menu fade-up">
                      <li>
                        <a
                          className="dropdown-item"
                          href="/auth/register?user_type=supplier"
                        >
                          {" "}
                          Become a Supplier
                        </a>
                      </li>
                      {/* {!isAuthenticated && <li><a className="dropdown-item" href="/auth/login"> My Profile</a></li>} */}
                    </ul>
                  </li>
                )}
                <li className="nav-item dropdown">
                  <a
                    className="nav-link  dropdown-toggle"
                    href="#"
                    data-bs-toggle="dropdown"
                  >
                    {" "}
                    Buyer{" "}
                  </a>
                  <ul className="dropdown-menu fade-up">
                    <li>
                      <a className="dropdown-item" href="/">
                        New User Guide
                      </a>
                    </li>
                    <li>
                      <a className="dropdown-item" href="/contact-us">
                        Contact Us
                      </a>
                    </li>
                    {user?.user_type === "3" && (
                      <li>
                        <a className="dropdown-item" href="/user/wishlist">
                          My Wishlist
                        </a>
                      </li>
                    )}
                  </ul>
                </li>
                <li className="nav-item dropdown">
                  <a
                    className="nav-link  dropdown-toggle"
                    href="#"
                    data-bs-toggle="dropdown"
                  >
                    {" "}
                    Help{" "}
                  </a>
                  <ul className="dropdown-menu dropdown-menu-end fade-up">
                    <li>
                      <a className="dropdown-item" href="/">
                        {" "}
                        Why trexopro.com
                      </a>
                    </li>
                    <li>
                      <a className="dropdown-item" href="/contact-us">
                        {" "}
                        Submit a Complaint
                      </a>
                    </li>
                    {/* <li><a className="dropdown-item" href="#">Contact Us</a></li> */}
                    <li>
                      <a className="dropdown-item" href="/faqs">
                        FAQ
                      </a>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </nav>
      </div>
      <SearchShow
        showSearchCanvas={showSearchCanvas}
        hideSearchCanvas={hideSearchCanvas}
        setSearchKeyword={setSearchKeyword}
        handleSearch={handleSearch}
        search={search}
        show={showSearch}
        searchKeyword={searchKeyword}
        searchedItems={searchedItems}
        isGlobalSearchLoading={isGlobalSearchLoading}
        handelSearchedItemSelection={handelSearchedItemSelection}
      />
    </>
  );
};
